import React from "react";
import { CartItem } from "../../Interfaces/Types";
import "./FullCartDisplay.css";
import { useCart } from "./CartContext";
import config from "../../config";
import ScrollToTop from "../../layout/ScrollToTop";
interface FullCartDisplayProps {
  onRemoveItem: (id: string) => void;
  onQuantityChange: (id: string, quantity: number) => void;
}

const FullCartDisplay: React.FC<FullCartDisplayProps> = ({
  onRemoveItem,
  onQuantityChange,
}) => {
  const { state } = useCart();
  const items: CartItem[] = state.cart;

  if (items.length === 0) {
    return <div>Your cart is empty</div>;
  }

  const calculateSubtotal = (price: number, quantity: number) =>
    (price * quantity).toFixed(2);

  return (
    <div className="shopping-cart-full-display-container">
      <ScrollToTop />
      <h2>Your Cart</h2>
      <div className="shopping-cart-full-display-header">
        <span className="shopping-cart-full-display-header-item">Item</span>
        <span className="shopping-cart-full-display-header-price">Price</span>
        <span className="shopping-cart-full-display-header-qty">Qty</span>
        <span className="shopping-cart-full-display-header-subtotal">
          Subtotal
        </span>
      </div>

      {items.map((item) => (
        <div key={item.id} className="shopping-cart-full-display-item">
          <div className="shopping-cart-full-display-item-details">
            <img
              src={`${item.image}`}
              alt={item.name}
              className="shopping-cart-full-display-item-image"
            />
            <div className="shopping-cart-full-display-item-info">
              <p className="shopping-cart-full-display-item-name">
                {item.name}
              </p>

              {/* Customization details as subtext */}
              {item.customization && (
                <div className="shopping-cart-full-display-item-customization-subtext">
                  {item.customization.bottle_text && (
                    <p>Text: {item.customization.bottle_text}</p>
                  )}
                  {item.customization.font_style && (
                    <p>Font Style: {item.customization.font_style}</p>
                  )}
                  {item.customization.clothing_size && (
                    <p>Size: {item.customization.clothing_size}</p>
                  )}
                  {item.customization.clothing_customization && (
                    <p>
                      Clothing Customization:{" "}
                      {item.customization.clothing_customization}
                    </p>
                  )}
                  {item.customization.design && (
                    <img
                      src={`${item.customization.design}` || ""}
                      alt="Customization"
                      className="shopping-cart-full-display-item-customization-image"
                    />
                  )}
                </div>
              )}

              <button
                onClick={() => onRemoveItem(item.id)}
                className="shopping-cart-full-display-remove-button"
              >
                Remove
              </button>
            </div>
          </div>

          <div className="shopping-cart-full-display-item-price">
            ${item.price.toFixed(2)}
          </div>

          <div className="shopping-cart-full-display-item-qty">
            <input
              type="number"
              value={item.quantity}
              onChange={(e) => {
                const quantity = parseInt(e.target.value);
                onQuantityChange(item.id, quantity);
              }}
              onBlur={(e) => {
                const quantity = parseInt(e.target.value) || 0; // Parse to 0 if NaN
                onQuantityChange(item.id, Math.max(1, quantity)); // Reset to 1 if less than 1
              }}
              className="shopping-cart-full-display-quantity-input"
            />
          </div>

          <div className="shopping-cart-full-display-item-subtotal">
            ${calculateSubtotal(item.price, item.quantity)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FullCartDisplay;
